module.exports = __webpack_public_path__ + "static/media/12596306_1061103970577691_233334087_n_edited.f843d1b4.jpg";